module.exports = __webpack_public_path__ + "img/descartaveisImage.0d5dc578.svg";